module.exports = __webpack_public_path__ + "img/0-3.f7f7186d.png";